import NewsFeed from './components/NewsFeed'
import CurrencyConverter from './components/CurrencyConverter'

function App() {
  return (
    <div className="App">
      <CurrencyConverter />
      <NewsFeed />
    </div>
  );
}

export default App;
